/**
 * URLs of the services the app talks to.
 *
 * The fallbacks take both host and scheme from `window.location` instead of
 * hardcoding `http://localhost`. A literal `localhost` would resolve to the
 * *client* machine when the dev server is opened from another device; a hardcoded
 * `http://`/`ws://` is blocked as mixed content — silently — once the page itself
 * is served over HTTPS. Deriving both is what makes a TLS-terminating proxy
 * possible, though a tunnel exposing only port 3000 still leaves these ports
 * unreachable whatever the scheme.
 *
 * This is why these vars are deliberately absent from `.env`: defining them there
 * pins every developer to localhost and defeats the fallback. On a deployed build
 * `requireDeployEnv()` in vite.config.ts fails the build when one is missing, so
 * the fallbacks never take effect in production.
 */

const { hostname, protocol } = window.location;
const isSecure = protocol === "https:";
const httpBase = `${isSecure ? "https" : "http"}://${hostname}`;
const wsBase = `${isSecure ? "wss" : "ws"}://${hostname}`;

export const BACKEND_URL =
  import.meta.env.VITE_BACKEND_URL || `${httpBase}:4000`;

export const GRAPHQL_BACKEND_URL =
  import.meta.env.VITE_GRAPHQL_BACKEND_URL || `${httpBase}:4002`;

export const ELT_WEBHOOK_API_URL =
  import.meta.env.VITE_ELT_WEBHOOK_API_URL || `${httpBase}:4017`;

export const WEBSOCKET_API_URL =
  import.meta.env.VITE_WEBSOCKET_API_URL || `${wsBase}:4007`;

export const WEBSITE_URL = (
  import.meta.env.VITE_WEBSITE_URL || "https://weld.app"
).replace(/\/$/, "");
export const WEBSITE_DOCS_API_URL = `${WEBSITE_URL}/api/docs`;
